export const mobileActionButtonClassNames = {
  expert: "btn btn-outline-secondary mobile-action-button mobile-action-button-expert",
  primary: "btn btn-primary mobile-action-button mobile-action-button-primary",
  secondary: "btn btn-outline-secondary mobile-action-button mobile-action-button-secondary",
  tertiary: "btn btn-link mobile-action-button mobile-action-button-tertiary",
} as const;

export type MobileActionButtonRole = keyof typeof mobileActionButtonClassNames;

export {
  createP1V4ReturnQuery as createMobileCoreLoopReturnQuery,
  createP1V4ReturnState as createMobileCoreLoopReturnState,
  createP2V2ReturnQuery as createMobileDecisionReturnQuery,
  createP2V2ReturnState as createMobileDecisionReturnState,
  createP3V1ReturnQuery as createMobileArchiveReturnQuery,
  createP3V1ReturnState as createMobileArchiveReturnState,
  getP2V2UrgencyRank as getMobileDecisionUrgencyRank,
  getP3V1VisibleRankingRows as getMobileVisibleRankingRows,
  P1SecondAuditActionableEmptyState as MobileActionableEmptyState,
  P1V4DecisionBar as MobileDecisionBar,
  P1V4FilterTrigger as MobileFilterTrigger,
  P1V4Section as MobileSection,
  P2V2DecisionQueueItem as MobileDecisionQueueItem,
  P2V2DecisionSummary as MobileDecisionSummary,
  P3V1ArchiveSeasonNav as MobileArchiveSeasonNav,
  P3V1Timeline as MobileTimeline,
  type P1V4ReturnStateInput as MobileCoreLoopReturnStateInput,
  type P2V2ReturnStateInput as MobileDecisionReturnStateInput,
  type P2V2Urgency as MobileDecisionUrgency,
  type P3V1ReturnStateInput as MobileArchiveReturnStateInput,
  type P3V1TimelineItem as MobileTimelineItem,
} from "./corePrimitives.tsx";

export {
  clampP5RankBarRatio as clampMobileRankBarRatio,
  P5ContentHero as MobileContentHero,
  P5EntityRow as MobileEntityRow,
  P5ExpertDisclosure as MobileExpertDisclosure,
  P5RankBar as MobileRankBar,
  P5StatRow as MobileStatRow,
  type P5ContentTone as MobileContentTone,
} from "./p5ContentPrimitives.tsx";

